import { render, staticRenderFns } from "./ContentSection.vue?vue&type=template&id=ff163eb6&scoped=true"
import script from "./ContentSection.vue?vue&type=script&lang=js"
export * from "./ContentSection.vue?vue&type=script&lang=js"
import style0 from "./ContentSection.vue?vue&type=style&index=0&id=ff163eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff163eb6",
  null
  
)

export default component.exports